import { pdpWidgetCookiePath } from './constants';

export const getValueFromCookie = (key: string) => {
	const valueFromCookie = document.cookie
		.split(';')
		.find((str) => str.includes(key))
		?.split('=')[1];
	return valueFromCookie;
};

export const setCookie = (key: string, value: string) => {
	document.cookie = `${key}=${value}; path=${pdpWidgetCookiePath()}`;
};
